import { render, staticRenderFns } from "./SingleLayerElementSimplified.vue?vue&type=template&id=84601308&scoped=true"
import script from "./SingleLayerElementSimplified.vue?vue&type=script&lang=ts"
export * from "./SingleLayerElementSimplified.vue?vue&type=script&lang=ts"
import style0 from "./SingleLayerElementSimplified.vue?vue&type=style&index=0&id=84601308&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84601308",
  null
  
)

export default component.exports